<template src="./unitDetailPage.template.html"></template>
<script>
    import moment from "moment-timezone";
    export default {
        name: "unitDetailPage",
        props: [],
        components: {
        },
        data() {
            return {
                fromBryntum: false,
                updateBookingCalendar: false,
                updateAvailabilityCalendar: false,
                showPrice: false,
                priceSymbol: "",
                disabledDates: [],
                availableDates: [],
                showFolio: false,
                checkAvailability: false,
                latLogList: [],
                loading: false,
                pageLoad: false,
                showCalenderError: false,
                disablePrevDates: true,
                disableAvailabilityPrevDates: true,
                selectedUnit: {},
                showError: false,
                isdisplay: 'none',
                showImages: false,
                guestList: [],
                guestListAdults: [],
                guestListChildren: [],
                showAdultandChildrenDropdown: false,
                showGuestsDropdown: false,
                isSearchCriteriaAvailable: false,
                searchObj: { Children: -99, Adults: -99, Persons: -99 },
                unitDataCSS: null,
                apiUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : ''),
                unitId: null,
                propertyId: null,
                unitData: {},
                showMoreAmenitiesCount: null,
                amenitiesList: [],
                amenitiesObj: [],
                showMoreText: false,
                showLessText: false,
                imageURLS: [],
                beData: {},
                folioItemCharges: [],
                folioCharges: {},
                selectedRatePlanId: null,
                selectedImageIndex: null,
                unavailableLatLong: [],
                maxDate: "",
                minDate: ""
            }
        },
        // beforeRouteLeave(to, from, next) {
        //     // Perform actions here 
        //     this.$store.state.filterObj.endDate = null;
        //     this.$store.state.filterObj.startDate = null;
        //     next();
        // },
        methods: {
            showAmenitiesList(type) {
                var vm = this;
                let list = [];
                for (let obj = 0; obj < vm.amenitiesObj.length; obj++) {
                    if (vm.amenitiesObj[obj].IsChecked == 1) {
                        list.push(vm.amenitiesObj[obj]);
                    }
                }
                if (type == 'showMore') {
                    vm.showMoreText = false;
                    // vm.showLessText = true;
                    vm.amenitiesList = list;
                }
                // if (type == 'showLess') {
                //     vm.showMoreText = true;
                //     vm.showLessText = false;
                //     vm.amenitiesList = list.slice(0,8);
                // }
            },
            scrollToElement(idname) {
                // const element = document.getElementById(idname);
                // element.scrollIntoView({ behavior: 'smooth', block: 'start' });

                var target = $(`#${idname}`)
                if (target.length > 0) {
                    // event.preventDefault();

                    // Calculate the height of the fixed header
                    var headerHeight = $('#custom-nav-bar').outerHeight();

                    // Apply padding to the target element
                    target.css('padding-top', headerHeight + 'px');

                    $('html, body').stop().animate({
                        scrollTop: target.offset().top - headerHeight
                    }, 100, function () {
                        // Remove the padding after scrolling is complete
                        target.css('padding-top', '');
                    });
                }
            },
            updateAvailabilityValues(values) {
                let vm = this;
                vm.updateBookingCalendar = !vm.updateBookingCalendar;
                if (values.startDate && values.startDate.getMonth() == new Date().getMonth() + 1 && values.startDate.getFullYear() == new Date().getFullYear()) {
                    vm.disablePrevDates = false;
                }
                setTimeout(() => {
                    console.log(values);
                    vm.updateCalendar(values, true);
                }, 50);
            },
            updateValues(values) {
                let vm = this;
                // vm.updateAvailabilityCalendar = !vm.updateAvailabilityCalendar;
                if (values.startDate) {
                    vm.minDate = moment(values.startDate).format();
                }
                setTimeout(() => {
                    console.log(values);
                    vm.updateCalendar(values);
                }, 50);
            },
            updateCalendar(values, isFromavailabilityCalendar) {
                let vm = this;
                if (values.startDate == null && values.endDate == null) {
                    vm.searchObj.startDate = null;
                    vm.searchObj.endDate = null;
                    vm.changeSearchAction(true);
                    return
                }
                vm.searchObj = {
                    ...vm.searchObj,
                    startDate: moment(values.startDate).format("YYYY-MM-DDTHH:mm:ss"),
                    endDate: moment(values.endDate).format("YYYY-MM-DDTHH:mm:ss")
                };

                vm.searchObj.startDate = null;
                vm.searchObj.endDate = null;
                this.$nextTick(() => {
                    vm.searchObj.startDate = moment(values.startDate).format("YYYY-MM-DDTHH:mm:ss");// Assign the original value
                    vm.searchObj.endDate = moment(values.endDate).format("YYYY-MM-DDTHH:mm:ss")

                    vm.$store.state.filterObj.startDate = vm.searchObj.startDate;
                    vm.$store.state.filterObj.endDate = vm.searchObj.endDate;
                    console.log("scope.searchObj Dates ==>", vm.searchObj.startDate, vm.searchObj.endDate);
                    vm.showCalenderError = false;
                    var isNotSameDate = new Date(vm.$store.state.filterObj.startDate).setHours(0, 0, 0, 0) != new Date(vm.$store.state.filterObj.endDate).setHours(0, 0, 0, 0)
                    if (isFromavailabilityCalendar && isNotSameDate && vm.isSearchCriteriaAvailable) {
                        vm.changeSearchAction(true); // if without change search action it displays only single folio summary without showing rate plans
                        vm.CheckAvailability();
                    }
                });

            },
            updateAvailabilityPreviousDates(value) {
                this.disableAvailabilityPrevDates = value;
            },
            updateDisablePrevDates(value) {
                this.disablePrevDates = value;
            },
            updateFilterEndDate() {

            },
            updateFilterStartDate() {
            },
            bookNow() {
                var vm = this;
                vm.$store.state.filterObj.unitId = vm.unitId;
                if (vm.beData.GuestPattern == 'Persons') {
                    vm.$store.state.filterObj.Persons = vm.searchObj.Persons;
                    vm.$store.state.filterObj.Adults = null;
                    vm.$store.state.filterObj.Children = null;
                } else if (vm.beData.GuestPattern == 'AdultsAndChildren') {
                    vm.$store.state.filterObj.Persons = null;
                    vm.$store.state.filterObj.Adults = vm.searchObj.Adults;
                    vm.$store.state.filterObj.Children = vm.searchObj.Children;
                }
                vm.$store.state.filterObj.RatePlanId = vm.selectedRatePlanId
                //vm.$store.state.filterObj.startDate = moment(vm.searchObj.startDate).format();
                //vm.$store.state.filterObj.endDate = moment(vm.searchObj.endDate).format();
                console.log("selectedUnit inst ===>", vm.selectedUnit);
                if (vm.selectedRatePlanId) {
                    this.$store.dispatch("guestInformation", {
                        data: {
                            selectedunit: vm.selectedUnit,
                        }
                    });
                    if(vm.$gtag){
                        vm.$gtag.event('Book now event', {
                            'event_category': 'Book Now',
                            'event_label': 'Book Now',
                        })
                    }
                    vm.$router.push("/guestInfo/" + -1);
                } else {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        message: "Please select rate plan",
                        header: "Warning",
                    });
                    console.log("Rate plan is not selected")
                }
            },
            showFolioSummary(ratePlan) {
                var vm = this;
                console.log("selectedUnit ==>", vm.selectedUnit);
                console.log("selected Rate Plan ==>", ratePlan);
                if (ratePlan) {
                    vm.selectedRatePlanId = ratePlan.RatePlanId;
                    vm.selectedUnit.RatePlanId = ratePlan.RatePlanId;
                    //vm.selectedUnit.Promocode = ratePlan.PromoCodes ? ratePlan.PromoCodes.join() : null;
                    vm.$store.state.filterObj.RatePlanId = ratePlan.RatePlanId;
                    //vm.$store.state.filterObj.Promocode = ratePlan.PromoCodes ? ratePlan.PromoCodes.join() : null;
                }
                vm.GetFolioLedgerTransDetails_beforesave();
                if(vm.$gtag){
                vm.$gtag.event('Show Folio Details', {
                        'event_category': 'Rate Plan',
                        'event_label': 'Rate Plan',
                    })
                }
            },
            CheckAvailability() {
                var vm = this;
                console.log("check availability")
                vm.showCalenderError = !vm.searchObj.startDate || !vm.searchObj.endDate ? true : false;
                if (vm.beData.GuestPattern == 'Persons') {
                    vm.showError = !vm.searchObj.Persons || vm.searchObj.Persons == -99 ? true : false;
                } else if (vm.beData.GuestPattern == 'AdultsAndChildren') {
                    vm.showError = !vm.searchObj.Adults || vm.searchObj.Adults == -99 ? true : false;
                }
                if (!vm.showError && !vm.showCalenderError) {
                    vm.checkAvailability = true;
                    if (vm.beData.GuestPattern == 'Persons') {
                        vm.$store.state.filterObj.Persons = vm.searchObj.Persons;
                        vm.$store.state.filterObj.Adults = null;
                        vm.$store.state.filterObj.Children = null;
                    } else if (vm.beData.GuestPattern == 'AdultsAndChildren') {
                        vm.$store.state.filterObj.Persons = null;
                        vm.$store.state.filterObj.Adults = vm.searchObj.Adults;
                        vm.$store.state.filterObj.Children = vm.searchObj.Children;
                    }
                    vm.$store.state.filterObj.RatePlanId = vm.selectedRatePlanId
                    vm.getAvailableRooms();
                }
                if(vm.$gtag){
                    vm.$gtag.event('Check for unit availability', {
                        'event_category': 'Check availability',
                        'event_label': 'Check availability',
                    })
                }
            },
            getAvailableRooms(values) {
                let vm = this;
                let sucessCallback = function (response) {
                    console.log("response in GetAvailability_BE", response);
                    if (response && response.data) {
                        if (response.data.roomDetailsListObjs) {
                            if (((vm.searchObj.endDate && vm.searchObj.startDate && (vm.searchObj.Persons || vm.searchObj.Adults)) || vm.checkAvailability) && response.data.roomDetailsListObjs.length > 0) {
                                vm.isSearchCriteriaAvailable = true;
                                if (response.data.roomDetailsListObjs.length == 1 && vm.checkAvailability) {
                                    vm.selectedUnit = response.data.roomDetailsListObjs[0];
                                    if (vm.selectedUnit.ratePlanList.length == 1) {
                                        vm.showFolio = true;
                                        vm.selectedRatePlanId = vm.selectedUnit.RatePlanId;
                                        vm.GetFolioLedgerTransDetails_beforesave();
                                    }
                                }
                            } else {
                                vm.isSearchCriteriaAvailable = false;
                                if (vm.checkAvailability) {
                                    vm.$store.dispatch("toastr", {
                                        type: "warning",
                                        message: "Unit is not available for the criteria selected. Please change your search criteria and try again.",
                                        header: "Check Availability",
                                    });
                                    console.log("Data is not available please change the search context")
                                }
                            }
                        }
                        // if (response.data.resultSet[4]) {
                        //     vm.unavailableLatLong = response.data.resultSet[4];
                        // }
                        // if (response.data.resultSet[3]) {
                        //     vm.latLogList = response.data.resultSet[3];
                        //     if (!values) {
                        //         if (!vm.checkAvailability) {
                        //             vm.addMarker();
                        //         }
                        //     }
                        // }
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };
                setTimeout(() => {
                    let unitDataObj = JSON.parse(JSON.stringify(vm.$store.state.filterObj));
                    // if (vm.checkAvailability) {
                    unitDataObj.unitId = vm.unitId;
                    unitDataObj.endDate = vm.searchObj.endDate;
                    unitDataObj.startDate = vm.searchObj.startDate;
                    unitDataObj.Promocode = vm.searchObj.Promocode
                    if (vm.beData.GuestPattern == 'Persons') {
                        unitDataObj.Persons = vm.searchObj.Persons;
                        unitDataObj.Adults = null;
                        unitDataObj.Children = null;
                    } else if (vm.beData.GuestPattern == 'AdultsAndChildren') {
                        unitDataObj.Persons = null;
                        unitDataObj.Adults = vm.searchObj.Adults;
                        unitDataObj.Children = vm.searchObj.Children;
                    }
                    // }
                    vm.$store.state.sendApiRequest("beApi/GetAvailability_BE", "post", unitDataObj, sucessCallback, failureCallback);
                }, 10);
            },
            addMarker() {
                let vm = this;
                vm.$store.state.bus.$emit('add-marker', {
                    latitudeLongitude: vm.latLogList,
                    unavailableLatLong: vm.unavailableLatLong,
                    MinZoomValue: vm.beData.MinZoomValue,
                    MaxZoomValue: vm.beData.MaxZoomValue
                });
            },
            clearAllSelectedDates() {
                var vm = this;
                vm.searchObj = {
                    ...vm.searchObj,
                    startDate: null,
                    endDate: null
                };
                vm.changeSearchAction(true);
            },
            showImageCarousel(imageIndex, skipActive) {
                var vm = this;
                $(".carousel-item").removeClass("active");
                $(".carousel-line").removeClass("active");
                vm.selectedImageIndex = imageIndex;
                if (skipActive) {
                    if ($(".carousel-item")[0]) {
                        $($(".carousel-item")[0]).addClass("active");
                    }
                    if ($(".carousel-line")[0]) {
                        $($(".carousel-line")[0]).addClass("active");
                    }
                }
                vm.showImages = true;
                vm.isdisplay = 'block';
                console.log("Show Image Carousel")
                $('.carousel').carousel({
                    interval: 2000
                });
            },
            closeCarousel() {
                var vm = this;
                vm.showImages = true;
                vm.isdisplay = 'none';
                vm.selectedImageIndex = null;
                console.log("Hide Image Carousel")
            },
            imageURL(imgGuid) {
                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid)
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + '/downloadImage/' + imgGuid + '/null';
            },
            getUnitDetailByID() {
                var vm = this;
                // vm.pageLoad = false
                // vm.loading = true
                var obj = {
                    ModuleAction: "GetUnitDetailById",
                    UnitId: vm.unitId,
                    PropertyId: vm.propertyId
                }
                var sucessCallback = function (response) {
                    console.log("GetUnitDetailById =>", response);
                    if (response) {
                        vm.unitData = response.data.UnitDataObj[0];
                        vm.unitData.Description = vm.unitData.Description ? vm.unitData.Description.replace(/\n/g, '<br>') : vm.unitData.Description;
                        vm.amenitiesObj = response.data.AminitiesObj ? response.data.AminitiesObj : vm.amenitiesObj;
                        let list = [];
                        if (vm.amenitiesObj) {
                            for (let obj = 0; obj < vm.amenitiesObj.length; obj++) {
                                if (vm.amenitiesObj[obj].IsChecked == 1) {
                                    list.push(vm.amenitiesObj[obj]);
                                }
                            }
                        }
                        if (list.length > 8) {
                            vm.showMoreText = true;
                            // vm.showLessText = false;
                            vm.amenitiesList = list.slice(0, 8);
                            vm.showMoreAmenitiesCount = list.length - 8;
                        } else {
                            // vm.showLessText = false;
                            vm.showMoreText = false;
                            vm.amenitiesList = list;
                        }
                        vm.imageURLS = response.data.ImgUrls;
                        vm.getPropertyDetailById();
                        if (vm.beData.GuestPattern == 'Persons') {
                            if (response.data.UnitDataObj[0].MaxPersons) {
                                let guestcount = response.data.UnitDataObj[0].MaxPersons;
                                if (vm.$store.state.filterObj.Persons != -99) {
                                    vm.searchObj.Persons = vm.$store.state.filterObj.Persons;
                                } else {
                                    vm.searchObj.Persons = (vm.beData.DefaultnoofGuests <= guestcount && vm.beData.DefaultnoofGuests != 0 && vm.beData.DefaultnoofGuests != null) ? vm.beData.DefaultnoofGuests : vm.beData.DefaultnoofGuests == 0 ? -99 : 2;
                                }
                                vm.showGuestsDropdown = true;
                                vm.showAdultandChildrenDropdown = false;
                                console.log("vm.guestList", guestcount);
                                vm.guestList = [];
                                for (let guest = 1; guest <= guestcount; guest++) {
                                    if (guest == 1) {
                                        vm.guestList.push({
                                            value: guest,
                                            Persons: guest + " " + " " + "guest",
                                        })
                                    }
                                    if (guest != 1) {
                                        vm.guestList.push({
                                            value: guest,
                                            Persons: guest + " " + " " + "guests",

                                        })
                                    }
                                }
                                console.log("vm.guestList", vm.guestList);
                            }
                        } else if (vm.beData.GuestPattern == 'AdultsAndChildren') {
                            if (response.data.UnitDataObj[0].MaxAdults) {
                                let guestcount = response.data.UnitDataObj[0].MaxAdults;
                                if (vm.$store.state.filterObj.Adults != -99) {
                                    vm.searchObj.Adults = vm.$store.state.filterObj.Adults;
                                } else {
                                    vm.searchObj.Adults = (vm.beData.Defaultnoofadults <= guestcount && vm.beData.Defaultnoofadults != 0 && vm.beData.Defaultnoofadults != null) ? vm.beData.Defaultnoofadults : vm.beData.Defaultnoofadults == 0 ? -99 : 2;
                                }
                                vm.showAdultandChildrenDropdown = true;
                                vm.showGuestsDropdown = false;
                                console.log("vm.guestList", guestcount);
                                vm.guestListAdults = [];
                                for (let guest = 1; guest <= guestcount; guest++) {
                                    if (guest == 1) {
                                        vm.guestListAdults.push({
                                            value: guest,
                                            Adults: guest + " " + " " + "Adult",
                                        })
                                    }
                                    if (guest != 1) {
                                        vm.guestListAdults.push({
                                            value: guest,
                                            Adults: guest + " " + " " + "Adults",

                                        })
                                    }
                                }
                                console.log("vm.guestList", vm.guestList);
                            }
                            if (response.data.UnitDataObj[0].MaxChildren) {
                                let guestcount = response.data.UnitDataObj[0].MaxChildren;
                                if (vm.$store.state.filterObj.Children != -99) {
                                    vm.searchObj.Children = vm.$store.state.filterObj.Children;
                                } else {
                                    vm.searchObj.Children = (vm.beData.Defaultnoofchildren <= guestcount && vm.beData.Defaultnoofchildren != 0 && vm.beData.Defaultnoofchildren != null) ? vm.beData.Defaultnoofchildren : -99;
                                }
                                vm.showAdultandChildrenDropdown = true;
                                vm.showGuestsDropdown = false;
                                console.log("vm.guestList", guestcount);
                                vm.guestListChildren = [];
                                for (let guest = 1; guest <= guestcount; guest++) {
                                    if (guest == 1) {
                                        vm.guestListChildren.push({
                                            value: guest,
                                            Children: guest + " " + " " + "Child",
                                        })
                                    }
                                    if (guest != 1) {
                                        vm.guestListChildren.push({
                                            value: guest,
                                            Children: guest + " " + " " + "Children",
                                        })
                                    }
                                }
                                console.log("vm.guestList", vm.guestList);
                            }
                        }
                    }
                    if (vm.selectedUnit.ratePlanList && vm.selectedUnit.ratePlanList.length == 1 && vm.isSearchCriteriaAvailable) {
                        vm.showFolio = true;
                        vm.selectedRatePlanId = vm.selectedUnit.RatePlanId;
                        vm.GetFolioLedgerTransDetails_beforesave();
                    }
                    vm.pageLoad = true
                    vm.loading = false
                }
                var failureCallback = function (response) {
                    console.log("failure response", response);
                }

                vm.$store.state.sendApiRequest("beApi/GetUnitDetailById", "post", obj, sucessCallback, failureCallback);
            },
            getPropertyDetailById() {
                var vm = this;
                var obj = {
                    ModuleAction: "GetPropertyDetailById",
                    PropertyId: vm.propertyId
                }
                var sucessCallback = function (response) {
                    console.log("getPropertyDetailById =>", response);
                    if (response) {
                        if (response.data.recordsets[5].length > 0) {
                            let unitAddress = [];
                            let address = response.data.recordsets[5][0].Address1;
                            let cityName = response.data.recordsets[5][0].CityName;
                            let stateName = response.data.recordsets[5][0].StateName;
                            if (address != undefined && address != "") {
                                unitAddress.push(address);
                            }
                            if (cityName != undefined && cityName != "") {
                                unitAddress.push(cityName);
                            }
                            if (stateName != undefined && stateName != "") {
                                unitAddress.push(stateName);
                            }
                            vm.$set(vm.unitData, 'AddressDetails', "")
                            vm.$set(vm.unitData, 'PolicyList', [])
                            vm.unitData.AddressDetails = unitAddress.join(", ").toString();
                        }
                        if (response.data.recordsets[4] && response.data.recordsets[4].length > 0) {
                            let propertyDetailObj = response.data.recordsets[4][0]
                            vm.latLogList = [{
                                latitude: propertyDetailObj.Latitude,
                                longitude: propertyDetailObj.Longitude,
                                Label: null
                            }]
                            vm.addMarker();
                            // vm.$store.state.bus.$emit("markLatitudeAndLongitude", { latitude: propertyDetailObj.Latitude, longitude: propertyDetailObj.Longitude });
                        }
                        if (response.data.recordsets[6].length > 0) {
                            vm.unitData.PolicyList = response.data.recordsets[6];
                        }
                    }
                }
                var failureCallback = function (response) {
                    console.log("failure response", response);
                }
                vm.$store.state.sendApiRequest("beApi/GetPropertyDetailById", "post", obj, sucessCallback, failureCallback);
            },
            Get_BookingEngine_Config() {
                let vm = this;
                let sucessCallback = function (response) {
                    if (response && response.data) {
                        console.log("response in Get_BookingEngine_Config", response);
                        if (response.data[1] && response.data[1].length) {
                            vm.beData = response.data[1][0];
                            vm.unitDataCSS = `<html><head><style>${
                                //vm.$store.state.beData.BEcss
                                vm.beData.BEcss
                                }</style></head><body></body></html>`;
                        }
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };
                vm.$store.state.sendApiRequest("beApi/Get_BookingEngine_Config", "post", {}, sucessCallback, failureCallback);
            },
            formatMoneyWithDecimals(amount) {
                return this.$store.state.getFormattedAmount("$", amount);
            },
            formatMoney(amount) {
                return this.$store.state.getFormattedAmountBE("$", amount);
            },
            formatStartDate(startDate, endDate) {
                let vm = this;
                let startYear = moment(startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(endDate, "YYYY-MM-DD").format("YYYY");
                if (startYear == endYear) {
                    return moment(startDate, "YYYY-MM-DD").format("DD MMM ");
                }
                else {
                    return moment(startDate, "YYYY-MM-DD").format("DD MMM YYYY");
                }
            },
            formatEndDate(endDate) {
                return moment(endDate, "YYYY-MM-DD").format("DD MMM YYYY");
            },
            NavigateToCancellationPolicyURL() {
                // window.open(inst.URL, inst.PropertyName + '-' + inst.UnitName);
                // window.open("https://hobokenvacationrentals.com/amazing-apartments/stylish-3br-retreat-w-private-deck-near-nyc/");
                let vm = this;
                window.open(vm.beData.Cancellationpolicyurl);
            },
            changeSearchAction(fromUpdateValues) {
                let vm = this;
                vm.isSearchCriteriaAvailable = false;
                vm.disablePrevDates = true;
                vm.selectedRatePlanId = null;
                vm.selectedUnit.RatePlanId = null;
                vm.$store.state.filterObj.RatePlanId = null;
                vm.searchObj.Promocode = null;
                // vm.selectedUnit.Promocode = ratePlan.PromoCodes ? ratePlan.PromoCodes.join() : null;
                // vm.$store.state.filterObj.Promocode = ratePlan.PromoCodes ? ratePlan.PromoCodes.join() : null;
                // vm.updateAvailabilityCalendar = !vm.updateAvailabilityCalendar;
                // vm.searchObj.Persons = vm.$store.state.filterObj.Persons;
                // vm.searchObj.Adults = vm.$store.state.filterObj.Adults;
                //vm.searchObj.Children = vm.$store.state.filterObj.Children;
                if (fromUpdateValues == undefined || !fromUpdateValues || typeof fromUpdateValues == 'object') {
                    vm.searchObj.Persons = vm.beData.DefaultnoofGuests <= vm.unitData.MaxPersons && vm.beData.DefaultnoofGuests != 0 ? vm.beData.DefaultnoofGuests : vm.beData.DefaultnoofGuests == 0 ? -99 : 2;
                    vm.searchObj.Adults = vm.beData.Defaultnoofadults <= vm.unitData.MaxAdults && vm.beData.Defaultnoofadults != 0 ? vm.beData.Defaultnoofadults : vm.beData.Defaultnoofadults == 0 ? -99 : 2;
                    vm.searchObj.Children = vm.beData.Defaultnoofchildren <= vm.unitData.MaxChildren && vm.beData.Defaultnoofchildren != 0 ? vm.beData.Defaultnoofchildren : -99;

                    vm.$store.state.filterObj.endDate = null;
                    vm.$store.state.filterObj.startDate = null;
                    vm.searchObj.endDate = vm.$store.state.filterObj.endDate;
                    vm.searchObj.startDate = vm.$store.state.filterObj.startDate;

                    this.minDate = null; // Temporarily set to null
                    this.$nextTick(() => {
                        this.minDate = moment().format("YYYY-MM-DD"); // Assign the original value
                    });

                }
                vm.showFolio = false
            },
            GetFolioLedgerTransDetails_beforesave() {
                let vm = this;
                let persons = "";
                let adults = "";
                let children = "";
                if (vm.fromBryntum) {
                    persons = vm.searchObj.Persons;
                    adults = null;
                    children = null;
                }
                if (vm.beData.GuestPattern == 'Persons') {
                    persons = vm.searchObj.Persons;
                    adults = null;
                    children = null;
                } else if (vm.beData.GuestPattern == 'AdultsAndChildren') {
                    adults = vm.searchObj.Adults;
                    children = vm.searchObj.Children;
                    persons = null;
                }
                let obj = {
                    FolioId: null,
                    ReservationId: null,
                    UnitId: vm.unitId,
                    PropertyId: vm.propertyId,
                    StartDate: vm.searchObj.startDate,
                    EndDate: vm.searchObj.endDate,
                    NumOfAdults: adults,
                    NumOfChildren: children,
                    Persons: persons,
                    RatePlanId: vm.selectedRatePlanId//vm.selectedUnit.RatePlanId
                };
                // vm.folioItemCharges = [];
                // vm.folioCharges = {};
                console.log("obj", obj)
                let sucessCallback = function (response) {
                    console.log("response in GetFolioLedgerTransDetails", response);
                    if (response && response.data) {
                        vm.showFolio = true;
                        if (response.data[0]) {
                            vm.folioItemCharges = response.data[0]
                        }
                        if (response.data[2]) {
                            vm.folioCharges = response.data[2][0];
                        }
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };
                vm.$store.state.sendApiRequest("beApi/GetFolioLedgerTransDetails", "post", obj, sucessCallback, failureCallback);
            },
            routeChangeEvent() {
                let vm = this;
                if(vm.$gtag){
                    vm.$gtag.pageview({
                        page_title: 'Unit Detail-Page',
                        page_location: window.location.href,
                        page_path: vm.$route.path,
                    })
                }
            },
            GETAvailability_Integration() {
                let vm = this;
                var days = 540; // Number of Days to add/subtract
                var currentDate = new Date();
                var lastDate = new Date(currentDate.getTime() + (days * 24 * 60 * 60 * 1000));
                let dateStart = moment(currentDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                let dateEnd = moment(lastDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                vm.maxDate = dateEnd;
                var params = {
                    unitId: vm.unitId,
                    DateStart: dateStart,
                    DateEnd: dateEnd
                }
                let sucessCallback = function (response) {
                    if (response && response.data) {
                        if (response.data.length) {
                            vm.availableDates.splice(0)
                            vm.disabledDates.splice(0)
                            var responseData = response.data[0];
                            for (let i = 0; i < responseData.length; i++) {
                                if (responseData[i].is_available && responseData[i].price != null) {
                                    vm.showPrice = true;
                                    vm.priceSymbol = responseData[i].Symbol;
                                    // var isCheckInAvailable = true;
                                    // var isCheckOutAvailable = true;
                                    // if (moment(responseData[i].stay_date, "YYYY-MM-DD").format("YYYY-MM-DD") == "2023-07-12") {
                                    //     isCheckInAvailable = false;
                                    // }
                                    // if (moment(responseData[i].stay_date, "YYYY-MM-DD").format("YYYY-MM-DD") == "2023-07-16") {
                                    //     isCheckOutAvailable = false;
                                    // }
                                    // if (moment(responseData[i].stay_date, "YYYY-MM-DD").format("YYYY-MM-DD") == "2023-07-04") {
                                    //     isCheckInAvailable = false;
                                    //     isCheckOutAvailable = false;
                                    // }
                                    let available = {
                                        date: (moment(responseData[i].stay_date, "YYYY-MM-DD").format("YYYY-MM-DD")),
                                        price: responseData[i].price, // adding price symbol to the price
                                        min_night_stay: responseData[i].min_night_stay,
                                        nocheckin: responseData[i].nocheckin,
                                        nocheckout: responseData[i].nocheckout
                                    }
                                    vm.availableDates.push(available)
                                } else if (!responseData[i].is_available || responseData[i].price == null) {
        
                                    // If there is a previous date and it is available
                                    if(i > 0 && responseData[i-1].is_available){
                                        // Create an object for the available date with a few custom properties
                                        let available = {
                                            date: (moment(responseData[i].stay_date, "YYYY-MM-DD").format("YYYY-MM-DD")),
                                            price: '',  // No price for this unavailable date
                                            min_night_stay: responseData[i].min_night_stay,
                                            nocheckin: true, // Mark that no check-in is allowed on this date
                                            nocheckout: responseData[i].nocheckout,
                                            manuallyEnabledDate: true // Custom flag for manually enabled dates
                                        }
                                        vm.availableDates.push(available)
                                    }else{
                                        vm.disabledDates.push(moment(responseData[i].stay_date, "YYYY-MM-DD").format("YYYY-MM-DD"));
                                    }
                                    // vm.disabledDates.push(moment(responseData[i].stay_date, "YYYY-MM-DD").format("YYYY-MM-DD"));
                                }
                            }
                            //console.log("Disabled dates ==> ", vm.disabledDates)

                        }
                        console.log("response in GETAvailability_Integration", response);
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };
                vm.$store.state.sendApiRequest("beApi/GETAvailability_Integration", "post", params, sucessCallback, failureCallback);
            },
            handleStartDateChange(newVal, oldValue) {
                console.log('Value changed:', newVal);
                console.log('Value max:', this.maxDate);
                var manuallyEnabledDates = this.availableDates.filter((date) => date && date.date >= this.searchObj.startDate && date.manuallyEnabledDate);
                const dates = manuallyEnabledDates.map(item => item.date);
                let max = this.disabledDates.filter((date) => date >= this.searchObj.startDate)
                max.push(...dates)
                console.log("chnage max val", max)
                function findMinimumDate(dates) {
                    let minDate = dates[0];

                    for (let i = 1; i < dates.length; i++) {
                        if (dates[i] < minDate) {
                            minDate = dates[i];
                        }
                    }

                    return minDate;
                }
                const minimumDate = findMinimumDate(max);
                this.maxDate = minimumDate
                console.log("chnage max val", minimumDate)
            },
            handleEndDateChange(newVal, oldVal) {
                console.log('Value changed:', newVal);
                var currentDate = new Date();
                var lastDate = new Date(currentDate.getTime() + (540 * 24 * 60 * 60 * 1000));
                let dateEnd = moment(lastDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                if (this.searchObj.startDate != this.searchObj.endDate) {
                    this.maxDate = dateEnd;
                }
            }
        },
        created() {
            this.$watch('searchObj.startDate', this.handleStartDateChange);
            this.$watch('searchObj.endDate', this.handleEndDateChange)
        },
        mounted() {
            var vm = this;
            vm.loading = true;
            vm.selectedUnit = vm.$store.getters.getUnitsData;
            setTimeout(() => {
                if(vm.$gtag){
                    vm.$gtag.pageview({
                        page_title: 'Unit Detail-Page',
                        page_location: window.location.href,
                        page_path: vm.$route.path,
                    })
                }
            }, 1000);
            vm.unitId = vm.$route.params.UnitId;
            vm.propertyId = vm.$route.params.PropertyId;
            $("#BE_Scroll").removeClass("showBE_Scroll");
            $("#BE_Scroll").addClass("dp");
            // vm.searchObj.Persons = vm.$store.state.filterObj.Persons;
            // vm.searchObj.Adults = vm.$store.state.filterObj.Adults;
            // vm.searchObj.Children = vm.$store.state.filterObj.Children;

            setTimeout(() => {
                if (Object.keys(vm.$route.query).length > 0) {
                // naviagtion from bryntum - start
                    console.log("vm.$route.query.Persons", vm.$route.query.Persons)
                    vm.searchObj.Persons = vm.$route.query.Persons;
                    console.log("vm.searchObj.Persons", vm.searchObj.Persons)
                    vm.searchObj.startDate = vm.$route.query.CheckIn;
                    vm.searchObj.endDate = vm.$route.query.CheckOut;
                    vm.unitId = vm.$route.query.UnitId;
                    vm.propertyId = vm.$route.query.PropertyId;
                    vm.selectedRatePlanId = vm.$route.query.RatePlanId;
                    vm.isSearchCriteriaAvailable = true;
                    vm.minDate = vm.$route.query.CheckIn;
                    vm.fromBryntum = true;

                    vm.$store.state.filterObj.Persons = vm.searchObj.Persons;
                    vm.$store.state.filterObj.Adults = null;
                    vm.$store.state.filterObj.Children = null;
                    vm.$store.state.filterObj.endDate = vm.searchObj.endDate;
                    vm.$store.state.filterObj.startDate = vm.searchObj.startDate;
                    vm.$store.state.filterObj.Promocode = null;
                    vm.$store.state.filterObj.RatePlanId = vm.selectedRatePlanId;
                    vm.$store.state.filterObj.unitId = vm.unitId;
                    vm.beData.GuestPattern = 'Persons';

                    vm.GetFolioLedgerTransDetails_beforesave()
                    vm.CheckAvailability()
                    // navigation from bryntum - end
                } else {
                    vm.searchObj.endDate = vm.$store.state.filterObj.endDate;
                    vm.searchObj.startDate = vm.$store.state.filterObj.startDate;
                    vm.searchObj.Promocode = vm.$store.state.filterObj.Promocode;
                    if (vm.searchObj.endDate && vm.searchObj.startDate && (vm.searchObj.Persons || (vm.searchObj.Adults))) {
                        vm.isSearchCriteriaAvailable = true;
                        vm.minDate = vm.searchObj.startDate;
                    } else {
                        vm.isSearchCriteriaAvailable = false;
                    }
                }
            }, 1000);
            vm.Get_BookingEngine_Config();
            vm.getUnitDetailByID();
            vm.GETAvailability_Integration();
            vm.pageLoad = false;
            $(document).ready(function () {
                $('.tabs li').click(function (event) {
                    $('li').removeClass("active");
                    $(this).addClass("active");
                    setTimeout(() => {
                        // vm.$router.push("#"+event.target.textContent.toLocaleLowerCase())
                        $(".unit-scroll").removeClass("active");
                        $("#" + event.target.textContent.toLocaleLowerCase()).addClass("active");
                        if (event.target.textContent.toLocaleLowerCase() == "policies") {
                            $("#" + event.target.textContent.toLocaleLowerCase()).find(".collapse-icon").attr("aria-expanded", "true");
                            $("#collapsePolicies").addClass("show in");
                        }
                    }, 50)
                });
            });
            // $('.carousel').carousel(); //default 5sec;
            // image-carousel slide for every 2 secs;
            $('.carousel').carousel({
                interval: 2000
            });
            vm.$store.state.bus.$emit("hidingSearch", false);
        },
        watch: {
            $route: "routeChangeEvent",

            // 'searchObj.startDate': function (newVal, oldVal) {
            //     // This function will be called when 'myObject.someKey' changes
            //     console.log('Value changed:', newVal);
            //     console.log('Value max:', this.maxDate);
            //     let max = this.disabledDates.filter((date) => date >= this.searchObj.startDate)
            //     console.log("chnage max val", max)
            //     function findMinimumDate(dates) {
            //         let minDate = dates[0];

            //         for (let i = 1; i < dates.length; i++) {
            //             if (dates[i] < minDate) {
            //                 minDate = dates[i];
            //             }
            //         }

            //         return minDate;
            //     }
            //     const minimumDate = findMinimumDate(max);
            //     this.maxDate = minimumDate
            //     console.log("chnage max val", minimumDate)
            // },
            // 'searchObj.endDate': function (newVal, oldVal) {
            //     console.log('Value changed:', newVal);
            //     var currentDate = new Date();
            //     var lastDate = new Date(currentDate.getTime() + (540 * 24 * 60 * 60 * 1000));
            //     let dateEnd = moment(lastDate, "YYYY-MM-DD").format("YYYY-MM-DD");
            //     if (this.searchObj.startDate != this.searchObj.endDate) {
            //         this.maxDate = dateEnd;
            //     }
            // }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/availabilitySearch/unitDetailPage.vue